// resolveSectionField — extracted from PartnerHotelsClient so the pure
// locale/shape resolution logic is unit-testable without the React tree.
//
// Kartik #108 (2026-04-28) — hotel section descriptions don't render on
// the landing page after cms#155 changed the storage shape from
// `{title: string, paragraphs: string}` to
// `{title: MultiLangValue, content: MultiLangValue}` per the per-locale
// tabs feature.
//
// Kartik #40 (2026-08-31) — legacy RateHawk-imported hotels (e.g. every
// hotel under package 115: Frankfurt/Lille/Brussel) store the body as
// `paragraphs: ["…string…", "…string…"]` — an ARRAY of plain strings.
// `typeof [] === "object"` so the old object branch tried `value["nl"]`
// (undefined for an array) and returned "", which dropped the entire
// description section. The Array branch below resolves each element
// (string OR MultiLangValue) and joins them with paragraph breaks.
//
// Supported shapes:
//   • plain string   → returned as-is
//   • MultiLangValue → resolves locale, EN → NL → DE → FR fallback ladder
//   • array          → each element resolved recursively, joined <br><br>
export const FALLBACK_LOCALES = ["nl", "en", "de", "fr"];

export function resolveSectionField(value, locale) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  // Legacy RateHawk import shape: an array of paragraph strings (or, in
  // theory, an array of MultiLangValue objects). Resolve each element and
  // join with paragraph breaks so the body renders instead of vanishing.
  if (Array.isArray(value)) {
    return value
      .map((v) => resolveSectionField(v, locale))
      .filter(Boolean)
      .join("<br /><br />");
  }
  if (typeof value === "object") {
    // Try requested locale first
    const direct = value[locale];
    if (typeof direct === "string" && direct.trim()) return direct;
    // Fall through the standard locale ladder
    for (const loc of FALLBACK_LOCALES) {
      if (loc === locale) continue;
      const v = value[loc];
      if (typeof v === "string" && v.trim()) return v;
    }
  }
  return "";
}
